import { Typography } from '@mui/material';

function DataItem({ title, data }: { title: string; data?: string }) {
  return (
    <div>
      <Typography
        variant='h4'
        sx={{ display: 'inline-block', fontWeight: 'normal', mr: 1, mb: 1 }}
        color='text.secondary'>
        {title}
      </Typography>
      <Typography
        variant='h4'
        sx={{ display: 'inline-block', fontWeight: 'bold' }}>
        {data}
      </Typography>
    </div>
  );
}

export default DataItem;
